import { IPricingWorkload } from "@shared/lib/types/pricingWorkload";
import { Table } from "@shared/ui";
import { Avatar } from "antd";
import { ColumnsType } from "antd/es/table";
import { UserCircle2 } from "lucide-react";
import { useMemo } from "react";
import styles from "../styles.module.scss";

interface PocWorkloadTableProps {
  workloads: IPricingWorkload[];
  isLoading: boolean;
  pricingAllocatedTo: string[];
}

export function PocWorkloadTable({
  workloads,
  isLoading,
  pricingAllocatedTo,
}: PocWorkloadTableProps) {
  const onBriefSet = useMemo(
    () => new Set(pricingAllocatedTo),
    [pricingAllocatedTo]
  );

  const columns: ColumnsType<IPricingWorkload> = [
    {
      title: "Pricing POC",
      key: "poc",
      render: (_, record) => {
        const onThisBrief = onBriefSet.has(record.user._id);
        return (
          <div className={styles.pocCell}>
            {record.user.profilePicUrl ? (
              <Avatar size={28} src={record.user.profilePicUrl} />
            ) : (
              <UserCircle2 size={22} color="#94a3b8" />
            )}
            <span className={styles.pocName}>
              {record.user.firstName} {record.user.lastName}
            </span>
            {onThisBrief ? (
              <span className={styles.onBriefChip}>This brief</span>
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Open briefs",
      key: "openBriefs",
      align: "right",
      width: 120,
      render: (_, record) => record.activeBriefsCount,
    },
    {
      title: "On queue",
      key: "onQueue",
      align: "right",
      width: 120,
      render: (_, record) => record.activeBriefInfluencersAllocatedCount,
    },
    {
      title: "Priced",
      key: "priced",
      align: "right",
      width: 120,
      render: (_, record) => record.activeBriefInfluencersPricedCount,
    },
    {
      title: "Left",
      key: "left",
      align: "right",
      width: 120,
      render: (_, record) =>
        record.activeBriefInfluencersAllocatedCount -
        record.activeBriefInfluencersPricedCount,
    },
  ];

  return (
    <Table<IPricingWorkload>
      className={styles.pocTable}
      rowKey={(record) => record.user._id}
      columns={columns}
      dataSource={workloads}
      loading={isLoading}
      pagination={false}
      size="middle"
      rowClassName={(record) =>
        onBriefSet.has(record.user._id) ? "selectedRow" : ""
      }
      locale={{
        emptyText: "No pricing POCs allocated to this brief.",
      }}
    />
  );
}
